import {
  keepPreviousData,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { dashboardMarkupTrendApi } from "@/features/dashboard/features/markup-trend-section/api";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";

export const useGetMarkupTrend = () => {
  const [searchParams] = useSearchParams();
  const brand_ids = useMemo(
    () => searchParams.getAll("brand_ids") ?? [],
    [searchParams]
  );

  const { data } = useQuery({
    queryKey: ["dashboard", "markup-trend", brand_ids],
    queryFn: () => dashboardMarkupTrendApi.getMarkUpTrend({ brand_ids }),
    select: (data) =>
      data.data.flatMap((item: any) => {
        const original = item;
        const copy = {
          season: item.season,
          line_sheet_set_type:
            item.line_sheet_set_type === "STOCK" ? "SEASON" : "STOCK",
          ...Object.fromEntries(
            Object.keys(item)
              .filter(
                (key) => key !== "season" && key !== "line_sheet_set_type"
              )
              .map((key) => [key, null])
          ),
        };
        return [original, copy];
      }),
    // select: (data) => data.data,
    enabled: brand_ids && brand_ids.length > 0,
    placeholderData: keepPreviousData,
  });

  return {
    markupTrendData: brand_ids.length > 0 ? data : brand_ids,
  };
};
